import styled from 'styled-components/macro';

export const Container = styled.div`
  display: flex;
  width: 100%;
  min-height: 100vh;
  align-items: flex-start;
  background-color: ${({ theme }) => theme.colors.gray[7]};
`;
